import React from "react";
import ReportComponent from "../components/Report";
import ServerMonitor from "../components/ServerReport"

function ReportView(props: {
  detectorData: any;
  fileData: any;
  reportGenAt: any;
  preferredColumnsOrder: any;
  expandedRow: any;
  setExpandedRow: any;
  onRefreshFileData: () => Promise<void>;
  fileDataLastModified: any;
  onFilePathSelect?: (filePath: string) => void;  // Add this line
}) {
  return (
    <div className="App-component">
      <ServerMonitor/>
      <ReportComponent
        detectorData={props.detectorData}
        fileData={props.fileData}
        reportGenAt={props.reportGenAt}
        preferredColumnsOrder={props.preferredColumnsOrder}
        expandedRow={props.expandedRow}
        setExpandedRow={props.setExpandedRow}
        onRefreshFileData={props.onRefreshFileData}
        fileDataLastModified={props.fileDataLastModified}
        onFilePathSelect={props.onFilePathSelect}  // Pass down to ReportComponent
      />
    </div>
  );
}

export default ReportView;
